import { useMutation } from 'react-query'

import { updateZervantSettings } from '../query-api'
import type { ZervantSettings } from '../types/zervantSettings'
import { useCopyInvoiceToEstimateUntilLaunch } from './useCopyInvoiceToEstimateUntilLaunch'

export const useUpdateZervantSettings = () => {
  const copyInvoiceToEstimateUntilLaunch = useCopyInvoiceToEstimateUntilLaunch()

  const {
    mutate: update,
    isLoading: isProcessing,
    ...rest
  } = useMutation((settings: Partial<ZervantSettings>) =>
    // This copy is removed when the Quote settings section launches (SILC-3209).
    updateZervantSettings(copyInvoiceToEstimateUntilLaunch(settings)),
  )

  return { update, isProcessing, ...rest }
}
